import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";
import { GameEngineVersion } from "./gameEngines.reducer";

export interface GameConfiguration {
    id: number;
    configuration: any;
    engine_version: GameEngineVersion;
    game: any;
    subsidiary: any;
    game_category: any;
    label: string;
    active: boolean;
    image?: string | null;
}

export function gameConfigurations(
    state: { results: GameConfiguration[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CONFIGURATIONS_SUCCESS:
            const configurations = action.payload.configurations
            configurations.results.map(conf=> {
                if(conf.configuration.default_coin) {
                    conf.configuration.default_coin.coin = conf.configuration.default_coin.coin && conf.configuration.default_coin.coin.toString();
                    conf.configuration.default_coin.coin = conf.configuration.default_coin.coin && conf.configuration.default_coin.coin.length > 0 ? conf.configuration.default_coin.coin.split().map(coin => Number(coin)) : []
                }
            })
            return configurations;

        case GamesActionTypes.CLEAR_GAME:
            return {
                results: [],
                count: 0
            };

        default:
            return state;
    }
}

export function gameConfigurationsLoading(
    state: boolean = true,
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CONFIGURATIONS:
            return true;

        case GamesActionTypes.GET_GAME_CONFIGURATIONS_FAIL:
        case GamesActionTypes.GET_GAME_CONFIGURATIONS_SUCCESS:
            return false;

        default:
            return state;
    }
}
